/**
 * WaitingForAIOverlay Component
 * 
 * Displays a subtle overlay while waiting for the first speaker
 */

import { useTranslation } from 'react-i18next';
import { getLocalizedCharacterName, MultilingualCharacterName } from '../utils/characterName';

interface WaitingForAIOverlayProps {
  characterName?: string | MultilingualCharacterName;
  firstSpeaker?: 'avatar' | 'user';
}

export default function WaitingForAIOverlay({ 
  characterName = 'Character',
  firstSpeaker = 'avatar'
}: WaitingForAIOverlayProps) {
  const { t, i18n } = useTranslation();
  
  // Get localized character name
  const localizedName = getLocalizedCharacterName(characterName, i18n.language);
  
  // Choose translation key based on firstSpeaker
  const translationKey = firstSpeaker === 'user' 
    ? 'scenario.session.youWillSpeakFirst'
    : 'scenario.session.waitingForCharacter';
  
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-30">
      <div className="text-center px-6 py-4">
        <div className="inline-flex flex-col items-center gap-3 bg-black/50 backdrop-blur-md rounded-2xl px-8 py-4 border border-white/10">
          {/* Spinner visível */}
          <div className="relative w-10 h-10">
            <div className="absolute inset-0 border-4 border-blue-500/30 border-t-blue-500 rounded-full animate-spin"></div>
          </div>
          <p className="text-white text-sm font-medium">
            {t(translationKey, { name: localizedName })}
          </p>
        </div>
      </div>
    </div>
  );
}

